export default __webpack_public_path__ + "static/media/rainbow.029c5aaa.png";